<template>
  <q-card square class="sticky-header-card">
    <div class="center-sticky-header">
      <div class="sticky-margin-vol-2">
        <div class="sticky-select">
          <q-select outlined dense :options="types" v-model="type" label="Type">
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
        <div class="sticky-location" v-if="type === 'Lease'">
          <q-select
            outlined
            dense
            :options="methods"
            v-model="method"
            label="Method"
          >
            <template v-slot:no-option>
              <q-item>
                <q-item-section class="text-italic text-grey">
                  There is no options.
                </q-item-section>
              </q-item>
            </template>
          </q-select>
        </div>
      </div>
    </div>
  </q-card>
</template>

<script>
export default {
  computed: {
    type: {
      get() {
        return this.$store.state.calculator.type;
      },
      set(val) {
        this.$store.commit("calculator/SET_TYPE", val);
      },
    },
    method: {
      get() {
        return this.$store.state.calculator.method;
      },
      set(val) {
        this.$store.commit("calculator/SET_METHOD", val);
      },
    },
    types() {
      return this.$store.state.calculator.types;
    },
    methods() {
      return this.$store.state.calculator.methods;
    },
  },
};
</script>